import { TabOption } from '../components/TabCreationModal';
import {
  BarChart,
  Table,
  FileText,
  Grid3x3,
  Code,
  GitBranch,
  UserCheck
} from 'lucide-react';
import React from 'react';

export const getTabCreationOptions = (hasDataset: boolean): TabOption[] => {
  const options: TabOption[] = [
    {
      id: 'data-table',
      label: 'Data Table',
      icon: React.createElement(Table, { size: 24 }),
      description: 'View and edit dataset',
      disabled: !hasDataset,
      requiresSelection: true // データセットの選択が必要
    },
    {
      id: 'statistics',
      label: 'Statistics',
      icon: React.createElement(BarChart, { size: 24 }),
      description: 'Statistical analysis',
      disabled: !hasDataset
    },
    {
      id: 'excluded-rows',
      label: 'Excluded Rows',
      icon: React.createElement(UserCheck, { size: 24 }),
      description: 'Manage excluded rows',
      disabled: !hasDataset
    },
    {
      id: 'report',
      label: 'Report',
      icon: React.createElement(FileText, { size: 24 }),
      description: 'Create reports',
      requiresSelection: true // レポートの選択が必要
    },
    {
      id: 'sql-editor',
      label: 'SQL Editor',
      icon: React.createElement(Code, { size: 24 }),
      description: 'Query data with SQL',
      disabled: !hasDataset
    },
    {
      id: 'glm',
      label: 'GLM',
      icon: React.createElement(BarChart, { size: 24 }),
      description: 'Generalized Linear Model (GLM) analysis',
      disabled: !hasDataset
    },
    {
      id: 'crosstab',
      label: 'Crosstab',
      icon: React.createElement(Grid3x3, { size: 24 }),
      description: 'Cross-tabulation analysis',
      disabled: !hasDataset
    },
    {
      id: 'graph-builder',
      label: 'Graph Builder',
      icon: React.createElement(BarChart, { size: 24 }),
      description: 'Create visualizations',
      disabled: !hasDataset
    },
    {
      id: 'project-overview',
      label: 'Project Overview',
      icon: React.createElement(FileText, { size: 24 }),
      description: 'Project information'
    },
    {
      id: 'project-lineage',
      label: 'Project Lineage',
      icon: React.createElement(GitBranch, { size: 24 }),
      description: 'Data lineage view'
    }
  ];

  return options;
};